export const getImageUrlFromPath = (path: string): string => {
  const imageFileName = path.split('/').pop();
  return `https://firebasestorage.googleapis.com/v0/b/deardoc-appointment-manager.appspot.com/o/images%2F${imageFileName}?alt=media`;
};
